module.exports = __webpack_public_path__ + "static/icons/icon-resort-guide--white-2979eadee0576d0e08a4bfb50f19a725.svg";